import React from 'react';
import { Link } from 'react-router-dom';
import EmergencyImg from '../../assets/emergency.png';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Emergency.scss';

const Emergency = () => {
    return (
      <section
        className="emergency-section"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="emergency-img">
                <img src={EmergencyImg} alt="Emergency" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="emergency-text">
                <SectionTitle
                  subTitle="Dental 24H Emergency"
                  title="Gentle, friendly treatment from our locally practice."
                  description=" Immediate care for dental pain, injuries, and urgent treatments—because your smile matters anytime, day or night."
                />

                <div className="theme-btn">
                  <Link to="/contact">Book an appointment</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Emergency;